<template>
  <avs-card>
    <template v-slot:title>
      <v-card-title class="pl-0">{{ $t("commons.drawer.privilege") }}</v-card-title>
    </template>
    <template v-slot:content>
      <v-container>
        <v-form
          :readonly="!isEditable"
          ref="form"
        >
          <v-expansion-panels>
            <v-expansion-panel
              v-for="(group, menu_name) in groupedItems"
              :key="menu_name"
            >
              <v-expansion-panel-header>
                {{ menu_name }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col
                    v-for="item in group"
                    :key="item.id"
                    class="col-3 d-flex justify-left"
                  >
                    <v-checkbox
                      v-model="selectedActions"
                      :label="translatedPermission(item.name)"
                      :value="item.id"
                      color="primary"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-col class="d-flex justify-end gap-4">
            <avs-saveButton
              @click="save"
              :disabled="!isEditable"
            />
            <avs-cancelButton @click="cancel" />
          </v-col>
        </v-form>
      </v-container>
    </template>
  </avs-card>
</template>

<script>
import { PrivilegeService, ActionService } from "@/services"

import _ from "lodash"

export default {
  name: "PrivilegeEditor",
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object
    },
    user: {
      type: Object
    }
  },
  computed: {
    privilege: {
      get() {
        return _.cloneDeep(this.value || this.getDefaultValue())
      }
    },
    projectId() {
      return this.$store.state.app.project.id
    },
    groupedItems() {
      return this.all_actions.reduce((acc, item) => {
        if (!acc[item.menu_name]) {
          acc[item.menu_name] = []
        }
        acc[item.menu_name].push(item)
        return acc
      }, {})
    }
  },
  data() {
    return {
      all_actions: [],
      selectedActions: [],
      check_privilege: null,
      userId: this.user.id
    }
  },
  created() {
    this.fetchFieldTypes()
    // this.initializeSelectedActions()
  },
  methods: {
    fetchFieldTypes() {
      ActionService.getAll().then(response => {
        this.all_actions = response
        this.initializeSelectedActions()
      })
    },
    initializeSelectedActions() {
      if (this.privilege.actions && this.privilege.actions.length > 0) {
        this.selectedActions = this.privilege.actions
      } else {
        this.selectedActions = this.all_actions.map(action => action.id)
      }
    },
    getDefaultValue() {
      return {
        project: this.projectId,
        user: this.userId,
        actions: []
      }
    },
    cancel() {
      this.$emit("cancel")
    },
    async performSave(data) {
      if (this.privilege.id) {
        return PrivilegeService.put(data)
      } else {
        return PrivilegeService.post(this.projectId, this.user.id, data)
      }
    },
    async save() {
      this.privilege.actions = this.selectedActions

      if (this.$refs.form.validate()) {
        this.performSave(this.privilege)
          .then(response => {
            this.$emit("input", response)
            this.$emit("success")
          })
          .catch(error => {
            const message = error?.response.data?.state
            this.$emit("error", message)
          })
      }
    },
    translatedEntity(entity) {
      const translationKeys = {
        "Non-Conformity": "commons.drawer.nonconformities",
        Inspection: "commons.drawer.inspections",
        Action: "commons.actions",
        "Quality Control Plan": "commons.drawer.pcq_dsi",
        Documentation: "commons.drawer.documentation",
        Gantt: "commons.drawer.gantt",
        Project: "commons.drawer.projects",
        Notification: "commons.drawer.notification",
        Tracability: "commons.drawer.timeline",
        CFSI: "commons.cfsi",
        "CFSI Action": "CFSI Action"
      }

      return this.$t(translationKeys[entity])
    },
    translatedPermission(entity) {
      const translationKeys = {
        Create: "commons.create",
        "Create Folder": "commons.create_folder",
        Delete: "commons.delete",
        Download: "commons.download",
        Modify: "commons.modify",
        "Generate Dossier": "commons.generate_dossier",
        "IA Analyse": "commons.ia_analyse",
        Meeting: "commons.meeting",
        "Rename File": "commons.rename_file",
        "Rename Folder": "commons.rename_folder",
        Send: "commons.send",
        Close: "commons.close",
        Display: "commons.display",
        "Delete Folder": "commons.delete_folder",
        "Delete File": "commons.delete_file",
        "Display Dossier": "commons.display_dossier",
        "Display Company Folder": "commons.display_company_folder",
        "Display Inspection": "commons.display_inspection",
        "Display Media": "commons.display_media",
        "Display Non-conformity": "commons.display_non_conformity",
        "Display Pcq/dsi": "commons.display_pcq_dsi",
        "Display CFSI": "commons.display_cfsi",
        Sign: "commons.sign",
        Upload: "commons.upload"
      }

      return this.$t(translationKeys[entity])
    }
  }
}
</script>
<style scoped>
.menu-name {
  font-weight: bold;
  color: #33597f !important;
}
</style>
